/**
 * Janko Piano - Settings Persistence Module
 * Handles saving and loading user preferences to localStorage
 * @version 0.2.63
 */

import { CONFIG } from './config.js';

// =============================================================================
// SETTINGS KEYS
// =============================================================================

const SETTINGS_KEYS = {
    ROWS: 'janko_rows',
    KEY_SHAPE: 'janko_keyShape',
    COLOR_SCHEME: 'janko_colorScheme',
    SPLIT_OCTAVE: 'janko_splitOctave',
    INSTRUMENT: 'janko_instrument',
    TEMPO: 'janko_tempo'
};

// =============================================================================
// SAVE SETTINGS
// =============================================================================

export function saveRows(value) {
    localStorage.setItem(SETTINGS_KEYS.ROWS, value.toString());
}

export function saveKeyShape(value) {
    localStorage.setItem(SETTINGS_KEYS.KEY_SHAPE, value);
}

export function saveColorScheme(value) {
    localStorage.setItem(SETTINGS_KEYS.COLOR_SCHEME, value);
}

export function saveSplitOctave(value) {
    localStorage.setItem(SETTINGS_KEYS.SPLIT_OCTAVE, value.toString());
}

export function saveInstrument(value) {
    localStorage.setItem(SETTINGS_KEYS.INSTRUMENT, value);
}

export function saveTempo(value) {
    localStorage.setItem(SETTINGS_KEYS.TEMPO, value.toString());
}

// =============================================================================
// LOAD SETTINGS
// =============================================================================

export function loadSettings() {
    const settings = {};
    
    // Load rows
    const rows = localStorage.getItem(SETTINGS_KEYS.ROWS);
    if (rows !== null) {
        settings.rows = parseInt(rows);
    }
    
    // Load key shape
    const keyShape = localStorage.getItem(SETTINGS_KEYS.KEY_SHAPE);
    if (keyShape !== null) {
        settings.keyShape = keyShape;
    }
    
    // Load color scheme
    const colorScheme = localStorage.getItem(SETTINGS_KEYS.COLOR_SCHEME);
    if (colorScheme !== null) {
        settings.colorScheme = colorScheme;
    }
    
    // Load split octave
    const splitOctave = localStorage.getItem(SETTINGS_KEYS.SPLIT_OCTAVE);
    if (splitOctave !== null) {
        settings.splitOctave = splitOctave === 'true';
    }
    
    // Load instrument
    const instrument = localStorage.getItem(SETTINGS_KEYS.INSTRUMENT);
    if (instrument !== null) {
        settings.instrument = instrument;
    }
    
    // Load tempo
    const tempo = localStorage.getItem(SETTINGS_KEYS.TEMPO);
    if (tempo !== null) {
        settings.tempo = parseFloat(tempo);
    }
    
    return settings;
}

// =============================================================================
// APPLY SETTINGS
// =============================================================================

export function applySettings(settings, updateMinimapFn) {
    // Apply to CONFIG
    if (settings.rows !== undefined) CONFIG.rows = settings.rows;
    if (settings.keyShape !== undefined) CONFIG.keyShape = settings.keyShape;
    if (settings.colorScheme !== undefined) CONFIG.colorScheme = settings.colorScheme;
    if (settings.splitOctave !== undefined) CONFIG.splitOctave = settings.splitOctave;
    
    console.log('Settings loaded from localStorage:', settings);
}

// =============================================================================
// CLEAR SETTINGS
// =============================================================================

export function clearAllSettings() {
    Object.values(SETTINGS_KEYS).forEach(key => {
        localStorage.removeItem(key);
    });
    console.log('All settings cleared');
}
